export const Info = {
  isBrioSku: ({ productSubType }) => {
    return !!(productSubType?.name === 'SFI');
  },
  isCustomKitchenCabinet: ({ productSubType, categoryHierarchy }) => {
    return !!(productSubType?.name === 'SFI'
      && categoryHierarchy?.find((category) => category === 'Custom Kitchen Cabinets'));
  }
};
